import React from 'react';
import {
  Box,
  Typography,
  Button,
  Toolbar,
  Paper,
  ButtonGroup
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

const BulkActionsToolbar = ({ 
  selectedCount, 
  onBulkDelete, 
  onBulkStatusChange,
  disabled = false 
}) => {
  if (selectedCount === 0) {
    return null;
  }

  return (
    <Paper 
      elevation={2} 
      sx={{ 
        mb: 2, 
        backgroundColor: '#e3f2fd',
        border: '1px solid #2196f3'
      }}
    >
      <Toolbar>
        <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
          <Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 600 }}>
            Acciones masivas
          </Typography>
          <Typography variant="body2" sx={{ ml: 2, color: '#1976d2' }}>
            {selectedCount} seleccionado{selectedCount !== 1 ? 's' : ''}
          </Typography>
        </Box>
        
        <ButtonGroup variant="contained" disabled={disabled}>
          <Button
            color="error"
            startIcon={<DeleteIcon />}
            onClick={onBulkDelete}
            sx={{ mr: 1 }}
          >
            Eliminar seleccionados
          </Button>
          <Button
            color="primary"
            startIcon={<EditIcon />}
            onClick={onBulkStatusChange}
          >
            Cambiar estado (progreso)
          </Button>
        </ButtonGroup>
      </Toolbar>
    </Paper>
  );
};

export default BulkActionsToolbar;